const en = {
  ACTIVITY_INFORMATION: 'ACTIVITY INFORMATION',
  SHOW_STATE_QUESTIONS: 'Show state questions',
  ASSESSMENTS_PER_PAGE: 'Assessments per page',
  PARTNER_INFORMATION: 'PARTNER INFORMATION',
  ADDITIONAL_INFORMATION: 'Additional information',
  CREATED_BY: 'Created by:',
  CREATED_ON: 'Created on:',
  'CURRENT LOGO': 'Current logo',
  'UPLOAD LOGO': 'Upload logo',
  'ORGANIZATION IDENTIFIER': 'Organization identifier',
  'ORGANIZATION FULL TITLE IN UKRAINIAN': 'Organization full title in Ukrainian',
  'ORGANIZATION FULL TITLE': 'Organization full title',
  'ORGANIZATION TITLE': 'Organization title',
  'EDIT ORGANIZATION': 'Edit Organization',
  'ADD ORGANIZATION': 'Add Organization',
  CREATE: 'Create',
  ADD: 'Add',
  DISCRIPTION: 'DISCRIPTION',
  SECTIONS: 'Sections',
  'CHANGE GEOGRAPHIC ACCESSIBILITY': 'Change geographic accessibility',
  'GEOGRAPHIC ACCESSIBILITY': 'Geographic accessibility',
  'SIGN IN': 'Sign in',
  'ACCOUNT REGISTRATION REQUEST': 'Account Registration Request',
  ACTIVITIES: 'Activities',
  BULK_TEMPLATE_TITLE_NEW: 'New bulk import Template',
  BULK_TEMPLATE_TITLE: 'Bulk Import Template',
  BULK_GUIDE_TITLE: 'Guide to Using the Bulk Import Template',
  DOWNLOAD: 'Download',
  IMPORT_WAITING_MESSAGE: 'Please be patient while we import and compare addresses with existing records. This process ensures that your data is accurately integrated into our system',
  Corpus: 'Block',
  'Multi-storey': 'Multi-apartment',
};

module.exports = en;
